import { useEffect, useState } from 'react'
import { newerBuild } from '../lib/update'
import { ButtonLink, EmptyState, Spinner } from './ui'

// How long to wait for a newer build to install and reload the page, once the
// check has found one. On a bad connection the page says so rather than spin.
const INSTALL_WAIT_MS = 10_000

/**
 * The page for a path the app doesn't know. It may only be this build that
 * doesn't know it: the service worker serves the app from its cache, so a link
 * to a route that a deploy added lands in the build from before. So it asks
 * for a newer build first, and says "Nothing here" only when there is none.
 */
export function NotFound() {
  const [missing, setMissing] = useState(false)

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined
    let gone = false
    void newerBuild().then((found) => {
      if (gone) return
      // Found: lib/update reloads when it is installed. Don't wait forever.
      if (found) timer = setTimeout(() => setMissing(true), INSTALL_WAIT_MS)
      else setMissing(true)
    })
    return () => {
      gone = true
      clearTimeout(timer)
    }
  }, [])

  if (!missing) {
    return (
      <div role="status" aria-label="Loading" className="grid min-h-dvh place-items-center text-muted">
        <Spinner />
      </div>
    )
  }
  return (
    <div className="mx-auto grid min-h-dvh max-w-md content-center px-4">
      <EmptyState title="Nothing here" action={<ButtonLink to="/" variant="primary" size="sm">Go home</ButtonLink>}>
        That page wandered off. Cats do that.
      </EmptyState>
    </div>
  )
}
